module.exports = "../../assets/img/photo-1523980669340-3d154e47d5fd.jpg";